import { Component, OnInit } from '@angular/core';
import { APP_TEXT_EN, APP_TEXT_ES } from '../../../shared/constants/app.constants';
import { GlobalService } from '../../../shared/services/global.service';
import { UtilService } from 'src/app/shared/services/utils.service';
import { SharedDataService } from 'src/app/shared/services/registration.service';


@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})

export class HeroComponent implements OnInit {

  public language : string = 'EN';
  public textConstants: any = this.language === 'EN' ? APP_TEXT_EN : APP_TEXT_ES;

  public preTitle!: string;
  public title!: string;
  public subtitle!: string;
  public heroImageURL: string = '../../../../assets/img/hero-default.webp';
  
  public ctaButtonText: string = this.textConstants.HERO.CTA_BUTTON_TEXT;
  public appointmentsAvailable: boolean = false;
  public ctaAppointmentText!: string;
  public ctaAppointmentButtonText!: string;//this.textConstants.HERO.CTA_APPOINTMENT_BUTTON_TEXT;
  public eventCount: number = 0;
  public logoURL: string = ''; // Used to look at the header section for spacing purposes
  heroImg!:string;
  langDictionary:any;
  ctaDisabled:boolean = false;

  constructor(private sharedDataService: SharedDataService, private scrollService: UtilService, private globalService: GlobalService) { }

  ngOnInit(): void {
    this.sharedDataService.ctaDisableData.subscribe(data=>{
      this.ctaDisabled = data;
    })
  this.langDictionary = this.globalService.Language;   
    this.scrollService.img$.subscribe((strimage) => {
      const heroElement = document.querySelector('.hero') as HTMLElement;
      this.globalService.jobInformation.subscribe((data) => {     
        this.appointmentsAvailable = data?.jobInfo?.AppointmentsAvailable ?? false;
        this.eventCount = data.eventCount || 0;
        if (this.eventCount < 2) {
          this.ctaButtonText = data?.pageData?.sectionHeader?.ctaButtonSelectEvent || this.langDictionary.HERO.CTA_BUTTON_TEXT_SINGLE;
        }else{
          this.ctaButtonText = data?.pageData?.sectionHeader?.ctaButtonSelectEvent || this.langDictionary.HERO.CTA_BUTTON_TEXT;
        }
        this.ctaAppointmentButtonText = (this.appointmentsAvailable)?data?.pageData?.sectionHeader?.ctaButtonMakeAppointment:this.langDictionary.HERO.CTA_APPOINTMENT_BUTTON_TEXT;
        this.ctaAppointmentText = (this.appointmentsAvailable)?data?.pageData?.sectionHeader?.ctaTextMakeAppointment:this.langDictionary.HERO.CTA_APPOINTMENT_TEXT;
        this.title = data?.pageData?.sectionHeader?.title;
        this.subtitle = data?.pageData?.sectionHeader?.subtitle; 
        this.preTitle = data?.pageData?.sectionHeader?.preTitle || this.langDictionary.HERO.PRETITLE;
        // Set logoURL for spacing purposes
        data.pageData && data.pageData.sectionHeader && data.pageData.sectionHeader.logoImageURL && data.pageData.sectionHeader.logoImageURL != '' ? this.logoURL = data.pageData.sectionHeader.logoImageURL : this.logoURL = '';      });
        
        
      if (heroElement) {
        const _strimage = ( strimage == '' || strimage == undefined || strimage == null)?"hero-default.webp":strimage;
        //this.heroImageURL = `url('../../../../assets/img/${strimage}')`
        this.heroImageURL = strimage.toUpperCase().includes('HTTPS')? `url('${strimage}')`:`url('../../../../assets/img/${strimage}')`
        heroElement.style.setProperty('--hero-image', this.heroImageURL);
      }
    })

  }

  register(){
    if(this.globalService.eventCount == 1){
      this.scrollService.triggerScroll('scrollToRegister');
    } else if(this.globalService.eventCount > 1){
      this.scrollService.triggerScroll('scrollToEvents');
    }
  }

}
